module.exports = __webpack_public_path__ + "media/how-it-works/relay-edbacd50.png";